import { render, staticRenderFns } from "./IconSvgLike.vue?vue&type=template&id=f23167e4&scoped=true&"
import script from "./IconSvgLike.vue?vue&type=script&lang=js&"
export * from "./IconSvgLike.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23167e4",
  null
  
)

export default component.exports